<template>
  <div class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>

      <v-toolbar-title class="pageTitle">
        Offene Tour-Daten
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div style="padding-top: 20px; padding-bottom: 80px;" class="contentWrapper checkoutContent" v-if="savedTours.length > 0">
      <div v-for="(tourData, index) in savedTours"
           :key="index" style="margin-bottom: 40px;">
        <div class="tour-main-card">
          <span>{{tourData.OrderNo}}</span>
          <span>{{tourData.CustNo}}</span>
          <span>{{tourData.CustName}}</span>
          <span>{{tourData.CustAddress}}</span>
          <span>{{tourData.CustPostCode}} {{tourData.CustCity}}</span>
          <span>{{tourData.CustPhone}}</span>
        </div>
        <v-btn class="tour-nav-forward-btn" @click="sendData(tourData)">
          Absenden
          <v-icon style="margin-left: 10px;">
            mdi-send-variant-outline
          </v-icon>
        </v-btn>
      </div>
    </div>
    <div v-if="dataSet" class="contentWrapper checkoutContent">
      Keine Daten vorhanden.
    </div>
  </div>
</template>

<script>

import { mapMutations } from "vuex";
import axios from "axios";
import router from "@/router";

export default {
  name: "Tours",
  data() {
    return {
      savedTours: [],
      dataSet: false
    }
  },
  mounted() {
    // saved customers
    let savedCustomers = localStorage.getItem('customers')
    if(savedCustomers) {
      savedCustomers = JSON.parse(savedCustomers)
    }
    let savedTourDataEntries = localStorage.getItem('currentSignaturesTourData')
    savedTourDataEntries = JSON.parse(savedTourDataEntries)
    const savedTours = []
    for(const[key, value] of Object.entries(savedTourDataEntries)) {
      const [orderNo, custNo, tour_id] = key.split('_')

      const customerIndex = savedCustomers.findIndex(el => el.customerNo == custNo)
      if(customerIndex > -1) {
        savedTours.push(
          {
            OrderNo: orderNo,
            CustNo: custNo,
            CustName: savedCustomers[customerIndex].marketName,
            CustAddress: savedCustomers[customerIndex].address,
            CustPostCode: savedCustomers[customerIndex].postal,
            CustCity: savedCustomers[customerIndex].city,
            tour_id: tour_id,
            signatures: value
          }
        )
      }
    }
    this.savedTours.push(...savedTours)
    this.dataSet = true
  },
  methods: {
    ...mapMutations({
      setRequestStateTourData: 'setRequestStateTourData',
      setRequestPendingTourData: 'setRequestPendingTourData',
      setLoadingOverlayTourData: 'setLoadingOverlayTourData'
    }),
    goBack() {
      router.go(-1)
    },
    async sendData(item) {
      const params = {
        tour_id: item.tour_id,
        orderNo: item.OrderNo,
        signature_jpeg: item.signatures.jpeg,
        customerNo: item.CustNo
      }
      try {
        this.setRequestPendingTourData(true)
        this.setLoadingOverlayTourData(true)
        const result = await axios.post('/api/tour-data-orders/store', params, {timeout: 40000}).catch(() => {

        })
        if(result?.data?.status === 1) {
          // immediate set
          this.setRequestStateTourData('success')
          this.setRequestPendingTourData(false)
          setTimeout(() => {
            this.setLoadingOverlayTourData(false)
            this.setRequestStateTourData(null)
          }, 3000)

          // remove signature
          let currentSignatures = JSON.parse(localStorage.getItem('currentSignaturesTourData'))
          if(currentSignatures && currentSignatures[`${item.OrderNo}_${item.CustNo}_${item.tour_id}`]) {
            delete currentSignatures[`${item.OrderNo}_${item.CustNo}_${item.tour_id}`]
            localStorage.setItem('currentSignaturesTourData', JSON.stringify(currentSignatures))
          }
          const removeIndex = this.savedTours.findIndex(el => el === item)
          if(removeIndex > -1) {
            this.savedTours.splice(removeIndex, 1)
          }
        } else {
          this.setRequestStateTourData('timeout')
          this.setRequestPendingTourData(false)
          setTimeout(() => {
            this.setLoadingOverlayTourData(false)
            this.setRequestStateTourData(null)
          }, 3000)
        }
      } catch (e) {
        console.warn(e)
      }
    }
  }
}
</script>

<style scoped>

</style>
